const de = {
  Taxonomy: {
    EditNode: 'Zutat bearbeiten',
    Save: 'Speichern',
    Saved: 'Zutat aktualisiert.',
    Active: 'Aktiv (zum Archivieren abwählen)',
    Archived: 'Archiviert',

    Title: 'Zutatenbaum',
    Subtitle: 'Klassen und validierte Annotationen erkunden und die Taxonomie erweitern.',
    Search: 'Nach Name oder Code suchen',
    Restaurant: 'Restaurant',
    AllRestaurants: 'Alle meine Restaurants',
    Project: 'Projekt',
    AllProjects: 'Alle Projekte',
    AnnotationType: 'Annotationstyp',
    BboxOnly: 'BBox',
    MaskOnly: 'Masken',
    BothTypes: 'BBox und Masken',
    Depth: 'Tiefe',
    Level: 'Ebene {{level}}',
    Reset: 'Ansicht zurücksetzen',
    Refresh: 'Aktualisieren',
    Loading: 'Taxonomie wird geladen',
    MapLabel: 'Taxonomiekarte',
    NoResults: 'Keine Knoten entsprechen dieser Suche.',
    Empty: 'Die Taxonomie ist leer. Importieren Sie zuerst die Referenztaxonomie.',
    NoBranches: 'Noch keine Zweige. Fügen Sie einen Knoten unter der Wurzel hinzu.',
    LoadError: 'Die Taxonomie konnte nicht geladen werden.',
    StatsError: 'Annotationszahlen sind nicht verfügbar.',
    CountsUnavailable: 'Annotationen: —',
    Retry: 'Erneut versuchen',
    Classes_one: '{{count}} untergeordnete Klasse',
    Classes_other: '{{count}} untergeordnete Klassen',
    Annotations_one: '{{formatted}} validierte Annotation',
    Annotations_other: '{{formatted}} validierte Annotationen',
    CountHelp:
      'Klassen: aktive auswählbare Nachfahren ohne den aktuellen Knoten. Annotationen: validierte Zuordnungen des Knotens und seiner aktiven Nachfahren für das ausgewählte Restaurant, Projekt und den Annotationstyp. Die Zahlen sind keine eindeutigen Bilder.',
    Expand: 'Aufklappen',
    Collapse: 'Zuklappen',
    Details: 'Knotendetails',
    SelectNode: 'Wählen Sie einen Knoten, um Definition, Pfad und Annotationszahlen zu sehen.',
    NoDefinition: 'Keine Definition vorhanden.',
    AnnotationDetails: 'Aufschlüsselung der validierten Annotationen',
    ValidatedAnnotations: 'Validierte Annotationen',
    Direct: 'Nur dieser Knoten',
    Subtree: 'Knoten und Nachfahren',
    BboxAssignments: 'Bbox-Zuordnungen',
    Masks: 'Masken',
    AddNode: 'Knoten hinzufügen',
    AddChild: 'Kindknoten hinzufügen',
    Parent: 'Elternknoten',
    Name: 'Name',
    Code: 'Code',
    Definition: 'Definition',
    Selectable: 'Für das Training auswählbar',
    NotSelectable: 'Nicht auswählbar',
    CodeHelp:
      'Eindeutiger unveränderlicher Code: Großbuchstaben, Ziffern und Unterstriche, beginnend mit einem Buchstaben.',
    NameInvalid: 'Geben Sie einen Namen mit 1 bis 256 Zeichen ein.',
    CodeInvalid: 'Verwenden Sie 1 bis 128 Zeichen: A–Z, 0–9 und _, beginnend mit einem Buchstaben.',
    CodeExists: 'Dieser Code existiert bereits, möglicherweise bei einem archivierten Knoten.',
    ParentRequired: 'Wählen Sie einen vorhandenen aktiven Elternknoten.',
    ImportRequired: 'Importieren Sie die Taxonomie, bevor Sie Knoten hinzufügen.',
    SaveError: 'Der Knoten konnte nicht erstellt werden. Prüfen Sie Ihren Zugriff und versuchen Sie es erneut.',
    Created: 'Der Knoten wurde erstellt.',
    Cancel: 'Abbrechen',
    Create: 'Erstellen',
    Saving: 'Wird erstellt…',
  },
  ProductCatalog: {
    Title: 'Produktkatalog',
    Categories: {
      indus_food: 'Industrieprodukte / Joghurts',
      drink: 'Getränke',
      fruit: 'Obst',
      snack: 'Snacks',
    },
    Search: 'Name, Marke oder ID suchen',
    SearchMinimum: 'Mindestens 3 Zeichen oder eine Produkt-ID eingeben.',
    SearchTooLong: 'Die Suche darf höchstens 255 Zeichen enthalten.',
    Brand: 'Marke',
    HasAnnotatedImages: 'Mit annotierten Bildern',
    All: 'Alle',
    Yes: 'Ja',
    No: 'Nein',
    NoBrand: 'Keine Marke',
    AnnotatedImages_one: '{{count}} annotiertes Bild',
    AnnotatedImages_other: '{{count}} annotierte Bilder',
    Restaurants: 'Restaurants, die dieses Produkt verwenden',
    RestaurantsTitle: 'Restaurants mit {{name}}',
    RestaurantsScope: 'Es werden nur aktive, Ihrem Konto zugeordnete Restaurants angezeigt.',
    NoRestaurants: 'Kein aktives zugeordnetes Restaurant verwendet dieses Produkt.',
    RestaurantsError: 'Restaurants konnten nicht geladen werden.',
    BrandsError: 'Marken konnten nicht geladen werden.',
    LoadError: 'Produkte konnten nicht geladen werden.',
    NoProducts: 'Keine Produkte entsprechen diesen Filtern.',
    ProductCount_one: '{{count}} Produkt',
    ProductCount_other: '{{count}} Produkte',
    RestaurantSearch: 'Restaurantname oder ID suchen',
    NoRestaurantMatches: 'Keine aktiven zugeordneten Restaurants entsprechen Ihrer Suche.',
    LoadingRestaurants: 'Restaurants werden geladen…',
    LoadMoreRestaurants: 'Weitere Restaurants laden',
    SortBy: 'Sortieren nach',
    SortOptions: {
      default: 'Standard',
      name_asc: 'Name: A–Z',
      name_desc: 'Name: Z–A',
      id_asc: 'ID: aufsteigend',
      id_desc: 'ID: absteigend',
      annotated_images_desc: 'Annotierte Bilder: absteigend',
      annotated_images_asc: 'Annotierte Bilder: aufsteigend',
    },
    ItemsPerPage: 'Produkte pro Seite',
    Retry: 'Erneut versuchen',
    Close: 'Schließen',
    Edit: 'Bearbeiten',
    Actions: 'Aktionen',
    NoImage: 'Kein Bild für dieses Produkt.',
    ImageError: 'Das Bild konnte nicht geladen werden.',
  },
  Navbar: {
    taxonomy: 'Zutatenbaum',
    product_catalog: 'Produktkatalog',
    catalog_industrials: 'Industrieprodukte / Joghurts',
    catalog_drinks: 'Getränke',
    catalog_fruits: 'Obst',
    catalog_snacks: 'Snacks',

    selfcheckout_subheader: 'Self-Checkout',
    dashboard: 'Übersicht',
    restaurant_products: 'Produkte',
    menus: 'Menüs',
    reports: 'Berichte',
    product_tools: 'Produkt-Tools',
    api_sandbox: 'API Sandbox',
    tools_subheader: 'Werkzeuge',
    correction: 'Berichtigung',
    merge: 'Zusammenführen',
    edit: 'Editieren',
    create: 'Erstellen',
    annotations: 'Anmerkungen',
    workspace: 'Annotationsarbeitsplatz',
    annotation_batches: 'Annotations-Batches',
    legacy_annotations: 'Annotationen (Legacy)',
    ingredients_check: 'Zutatenprüfung',
    ingredients_crop: 'Zutatenzuschnitt',
    admin_subheader: 'Administration',
    users: 'Benutzer',
    list: 'Liste',
    restaurants: 'Restaurants',
    itentification_token: 'Identifizierung (Token)',
    visualization: 'Visualisierung',
    clients: 'Kunden',
    ingredients_mapping: 'Zutatenzuordnung',
  },
  IngredientProductMappings: {
    Page_Title: 'Zutatenzuordnungen',
    Heading: 'Zutatenzuordnungen',
    Actions: {
      Create: 'Zuordnung hinzufügen',
    },
    Table: {
      Ingredient: 'Zutat',
      Product: 'Produkt',
      Scope: 'Geltungsbereich',
      Restaurant: 'Restaurant',
      Restaurant_Product: 'Restaurantprodukt',
    },
    Badges: {
      Fallback: 'Fallback',
      Additive: 'Additiv',
    },
    Scope: {
      all: 'Alle Geltungsbereiche',
      global: 'Global',
      restaurant: 'Restaurant-Override',
    },
    Toolbar: {
      Search_Placeholder: 'Zutat, Produkt oder Restaurantprodukt suchen...',
      Scope_Label: 'Geltungsbereich',
      Restaurant_Context: 'Restaurant-Override-Kontext: {{restaurant}}',
      Restaurant_Missing: 'Wählen Sie ein Restaurant aus, um Restaurant-Overrides anzuzeigen und zu verwalten.',
      No_Restaurant: 'Kein Restaurant ausgewählt',
    },
    Dialog: {
      Create_Title: 'Zutatenzuordnung erstellen',
      Edit_Title: 'Zutatenzuordnung bearbeiten',
      Create_Action: 'Zuordnung erstellen',
      Save_Action: 'Änderungen speichern',
      Scope_Label: 'Zuordnungsbereich',
      Ingredient_Label: 'Zutat',
      Product_Label: 'Kanonisches Produkt',
      Restaurant_Product_Label: 'Restaurantprodukt',
      Product_Search_Hint: 'Produkte nach Name oder ID suchen',
      Product_Search_Minimum: 'Mindestens {{count}} Zeichen oder eine Produkt-ID eingeben',
      Product_Search_Error: 'Produktsuche nicht möglich',
      No_Products: 'Keine Produkte gefunden',
      Restaurant_Context: 'Ziel des Restaurant-Overrides: {{restaurant}}',
      Derived_Product: 'Das kanonische Produkt wird aus {{product}} abgeleitet.',
      Show_Conflict: 'Bestehende Zuordnung anzeigen',
      Fallback_Label: 'Fallback-Produkt',
      Fallback_Helper: 'Wird verwendet, wenn das Klassifikator-Elternprodukt mit keinem Ziel kompatibel ist.',
      Additive_Label: 'Additive Zutat',
      Additive_Helper: 'Diese Einstellung gilt global für die Zutat und ergänzt inkompatible Elternprodukte.',
    },
    Delete: {
      Title: 'Zutatenzuordnung löschen',
      Description: 'Die Zuordnung zwischen {{ingredient}} und {{product}} löschen?',
      Confirm: 'Zuordnung löschen',
      Fallback_Required: 'Wählen Sie vor dem Löschen dieser Zuordnung ein anderes Fallback-Produkt.',
    },
    Snackbar: {
      Create_Success: 'Zutatenzuordnung erfolgreich erstellt',
      Update_Success: 'Zutatenzuordnung erfolgreich aktualisiert',
      Delete_Success: 'Zutatenzuordnung erfolgreich gelöscht',
      Save_Error: 'Fehler beim Speichern der Zutatenzuordnung',
      Conflict_Error: 'Die Zuordnungskonfiguration steht im Konflikt mit dem ausgewählten Geltungsbereich.',
      Delete_Error: 'Fehler beim Löschen der Zutatenzuordnung',
      Load_Error: 'Fehler beim Laden der Zutatenzuordnungen',
    },
    Rows_Per_Page: 'Zuordnungen pro Seite',
    Dense: 'Dicht',
  },
  AnnotationWorkspace: {
    Ingredient: 'Zutat',
    AnnotationChanges: 'Annotationsänderungen',
    ModifiedBy: 'Geändert von',
    ModifiedBetween: 'Geändert zwischen',
    ClearModificationDates: 'Änderungsdaten löschen',
    UnableToLoadHistoryUsers: 'Benutzer aus dem Annotationsverlauf konnten nicht geladen werden.',

    DisplayOptions: 'Anzeigeoptionen',
    ShowIngredientsInBoxList: 'Zutaten in der Boxliste anzeigen',
    CollapseInspector: 'Inspektor einklappen',
    ExpandInspector: 'Inspektor ausklappen',
    MultipleRestaurants: 'Mehrere Restaurants',
    SelectRestaurant: 'Restaurant auswählen',
    DetectionScore: 'Erkennungswert',
    IngredientDetectionScore: 'Zutatenerkennungswert',
    MinimumScore: 'Min',
    MaximumScore: 'Max',
    ApplyScores: 'Werte anwenden',
    InvalidScore: 'Prozentwert zwischen 0 und 100 eingeben',
    InvalidScoreRange: 'Maximum muss mindestens dem Minimum entsprechen',
    UnableToLoadFilterOptions: 'Filteroptionen konnten nicht geladen werden',
    PageTitle: 'Annotationsarbeitsplatz',
    LegacyPageTitle: 'Annotationen: Bilder (Legacy)',
    PageHeading: 'Annotationsarbeitsplatz',
    Dashboard: 'Übersicht',
    Annotations: 'Anmerkungen',
    AnnotationWorkspace: 'Annotationsarbeitsplatz',
    Images: 'Bilder',
    Filters: 'Filter',
    Close: 'Schließen',
    Refresh: 'Aktualisieren',
    AutoRefresh: 'Automatisch aktualisieren',
    AutoRefreshOff: 'Aus',
    AutoRefreshSeconds: '{{count}} s',
    AutoRefreshMinutes: '{{count}} min',
    UnableToRefreshAnnotations: 'Anmerkungen konnten nicht aktualisiert werden',
    Save: 'Speichern',
    ResultRail: 'Ergebnisleiste',
    NewestFirst: 'Neueste zuerst',
    OldestFirst: 'Älteste zuerst',
    ChangeImageOrder: 'Bildreihenfolge ändern',
    Workspace: 'Arbeitsbereich',
    Inspector: 'Inspektor',
    Context: 'Kontext',
    Details: 'Details',
    Ingredients: 'Zutaten',
    History: 'Verlauf',
    Tickets: 'Tickets',
    Restaurant: 'Restaurant',
    FromDate: 'Von Datum',
    ToDate: 'Bis Datum',
    DateRange: 'Zeitraum',
    SelectStartDate: 'Startdatum auswählen',
    SelectEndDate: 'Enddatum auswählen',
    Apply: 'Anwenden',
    Cancel: 'Abbrechen',
    Product: 'Produkt',
    ObjectClass: 'Objektklasse',
    ImageValidation: 'Bildvalidierung',
    Enrollment: 'Enrollment',
    TicketPresence: 'Ticket vorhanden',
    AnnotationPresence: 'Boxen vorhanden',
    IngredientPresence: 'Zutatenannotationen',
    Camera: 'Kamera',
    UseDailyProductsOnly: 'Nur Tagesprodukte verwenden',
    AllProducts: 'Alle Produkte',
    Reset: 'Zurücksetzen',
    All: 'Alle',
    Yes: 'Ja',
    No: 'Nein',
    ValidatedOnly: 'Nur validierte',
    NeedsValidation: 'Benötigt Validierung',
    EnrolledOnly: 'Nur enrollte',
    NotEnrolled: 'Nicht enrolled',
    HasTicketOnly: 'Mit Tickets',
    WithoutTicket: 'Ohne Tickets',
    HasAnnotationsOnly: 'Mit Boxen',
    WithoutAnnotations: 'Ohne Boxen',
    HasIngredientsOnly: 'Mit Zutatenannotationen',
    WithoutIngredients: 'Ohne Zutatenannotationen',
    ImageValidated: 'Bild validiert',
    Enrolled: 'Enrolled',
    Ticket: 'Ticket',
    TraysCount: '{{count}} Tabletts',
    TrayNumber: 'Tablett {{id}}',
    ValidatedBboxCount: '{{validated}}/{{total}} validiert',
    UnknownTime: 'Unbekannte Zeit',
    UnableToLoadSummaries: 'Bildzusammenfassungen konnten nicht geladen werden.',
    NoTraysMatchFilters: 'Keine Tabletts entsprechen den aktuellen Filtern.',
    CopyLink: 'Link kopieren',
    EditTools: 'Bearbeiten',
    SelectBox: 'Auswählen',
    DrawBox: 'Box zeichnen',
    ViewOptions: 'Ansicht',
    RunAI: 'KI starten',
    SearchExistingProducts: 'Produkte suchen',
    ExistingProductProposals: 'Vorschläge vorhandener Produkte',
    ProductSearchArea: 'Suchbereich',
    ProductSearchAutomatic: 'Gesamtes Bild (automatische Erkennung)',
    ProductSearchBox: 'Bbox {{id}}',
    ProductSearchSelectedBoxHint: 'Die Suche schneidet diese Bbox direkt zu, ohne Erkennung.',
    ProductSearchAutomaticHint: 'Wählen Sie eine Bbox, um nur nach dem darin enthaltenen Produkt zu suchen.',
    ProposalImageNumber: 'Bild {{number}}',
    NoImageToSearch: 'Kein Bild für die Suche verfügbar.',
    SearchingExistingProducts: 'Vorhandene Produkte werden gesucht',
    UnableToSearchProducts: 'Produkte konnten nicht gesucht werden. Bitte erneut versuchen.',
    NoExistingProductsFound: 'Keine passenden Produkte für dieses Bild gefunden.',
    ProposalProductNumber: 'Produkt {{id}}',
    ProposalMatchScore: 'Übereinstimmung: {{score}} %',
    CloseProductSearch: 'Schließen',
    SearchProductsAgain: 'Erneut suchen',
    MoreActions: 'Weitere Aktionen',
    MoreBboxActions: 'Weitere Box-Aktionen',
    AllChangesSaved: 'Änderungen gespeichert',
    SavingChanges: 'Wird gespeichert…',
    AddBox: 'Box hinzufügen',
    BatchMenu: 'Batch',
    BatchActions: 'Batch-Aktionen',
    ActiveBatch: 'Aktiver Batch',
    BatchFilteredResults_one: '{{count}} gefiltertes Bild',
    BatchFilteredResults_other: '{{count}} gefilterte Bilder',
    ValidateFilteredBatch: 'Batch validieren',
    ValidateFilteredBatchHint: 'Validiert die gefilterten Bilder und alle zugehörigen Boxen.',
    ValidateFilteredBatchConfirm:
      'Alle Boxen und Bilder der {{count}} gefilterten Batch-Ergebnisse validieren? Die Änderungen werden sofort gespeichert.',
    ValidateFilteredBatchProgress: 'Validierung: {{completed}} / {{total}} Bilder',
    ValidateFilteredBatchSuccess: '{{count}} Bilder validiert.',
    ValidateFilteredBatchError:
      'Validierung nach {{count}} Bildern unterbrochen. Gespeicherte Änderungen bleiben erhalten.',
    ValidateAll: 'Alle validieren',
    UnvalidateAll: 'Alle entvalidieren',
    Analyze: 'Analysieren',
    Restore: 'Wiederherstellen',
    UnsavedChanges: 'Ungespeicherte Änderungen',
    EnrolledImage: 'Enrolled Bild',
    PickTrayHint: 'Wählen Sie ein Tablett aus der Ergebnisleiste, um den Editor zu öffnen.',
    CapturedAt: 'Aufgenommen um',
    Revision: 'Revision',
    ActiveCamera: 'Aktive Kamera',
    ImageMedia: 'Bildmedium',
    TrayMeal: 'Tray Meal',
    SelectProductBoxHint: 'Wählen Sie im Canvas eine Produktbox aus, um deren Zutaten zu prüfen und zu bearbeiten.',
    IngredientEditorInWorkspace: 'Die Zutatenbearbeitung ist im Hauptarbeitsbereich geöffnet.',
    SelectedProductBox: 'Ausgewählte Produktbox',
    Selected: 'Ausgewählt',
    KeyboardNavigationHint: '← / → vorheriges und nächstes Bild',
    Shortcuts: 'Tastenkürzel',
    KeyboardShortcuts: 'Tastenkürzel',
    ProductModeShortcuts: 'Produktannotationsmodus',
    IngredientModeShortcuts: 'Zutatenannotationsmodus',
    PreviousImage: 'Vorheriges Bild',
    NextImage: 'Nächstes Bild',
    SaveAnnotations: 'Annotationen speichern',
    CancelChanges: 'Änderungen verwerfen',
    ToggleAddBox: 'Produktbox hinzufügen umschalten',
    OpenClassQuickMenu: 'Boxklasse am Mauszeiger auswählen',
    OpenProductQuickMenu: 'Boxprodukt am Mauszeiger auswählen',
    QuickMenuTitle: 'Ausgewählte Box bearbeiten',
    QuickMenuValidate: 'Box validieren',
    QuickMenuInvalidate: 'Validierung der Box aufheben',
    QuickMenuDelete: 'Box löschen',
    AutoOpenBoxQuickMenu: 'Menü nach dem Zeichnen einer Box öffnen',
    QuickMenuClass: 'Klasse',
    QuickMenuProduct: 'Produkt',
    QuickMenuSearch: 'Suchen…',
    QuickMenuRecentChoices: 'Zuletzt ausgewählt',
    QuickMenuLoading: 'Produkte werden geladen…',
    QuickMenuNoClasses: 'Keine Klassen verfügbar',
    QuickMenuKeyboardHint: '↑ ↓ navigieren · Enter auswählen · Esc schließen',
    ToggleImageValidation: 'Bildvalidierung umschalten',
    ValidateAllBoxes: 'Validierung der ausgewählten Produktbox umschalten (alle, wenn keine ausgewählt ist)',
    DeleteSelectedBox: 'Ausgewählte Produktbox löschen',
    OpenIngredientMode: 'Zutatenmodus öffnen',
    ToggleIngredientBox: 'Zutatenbox hinzufügen umschalten',
    ValidateIngredientBoxes: 'Validierung der ausgewählten Zutatenbox umschalten (alle, wenn keine ausgewählt ist)',
    DeleteSelectedIngredientBox: 'Ausgewählte Zutatenbox löschen',
    BackToImage: 'Zurück zum Bild',
    IngredientCrops: 'Produktausschnitte',
    NoProductCrops: 'Keine Produktausschnitte in diesem Bild',
    CropNavigation: 'Ausschnittnavigation',
    CropValidated: 'Ausschnitt validiert',
    UnsavedIngredientChangesTitle: 'Zutatenänderungen speichern?',
    UnsavedIngredientChangesDescription:
      'Sie haben Zutaten in dieser Sitzung geändert. Speichern Sie sie, verwerfen Sie nur diese Zutatenänderungen oder bearbeiten Sie weiter.',
    SaveAndReturn: 'Speichern und zurück',
    DiscardAndReturn: 'Verwerfen und zurück',
    KeepEditing: 'Weiter bearbeiten',
    SaveProductBeforeAnalysis: 'Speichern Sie diese Produktbox vor der Zutatenanalyse.',
    ExitIngredientMode: 'Zum Bild zurückkehren',
    JumpToImage: 'Zu einem Bild springen',
    ImagePosition: '{{current}} / {{total}}',
    ViewingPosition: 'Ansicht {{current}} / {{total}}',
    NearbyImages: '{{count}} in der Nähe',
    ProductBoxNumber: 'Produktbox #{{id}}',
    UnableToLoadTickets: 'Tickets konnten nicht geladen werden.',
    ClientResponse: 'KI-Antwort',
    TicketItems: 'Bonartikel',
    ResponseHistory: 'Antwortverlauf',
    ProductsReturned: 'Zurückgegebene Produkte',
    NoProductsReturned: 'Keine Produkte zurückgegeben',
    UnknownReturnedProduct: 'Unbekanntes Produkt',
    RawJson: 'JSON-Rohdaten',
    NoClientResponses: 'Keine KI-Antwort für dieses Tablett gespeichert.',
    UnableToLoadClientResponses: 'Gespeicherte KI-Antworten konnten nicht geladen werden.',
    NoTicketRows: 'Für dieses Tablett wurden keine CSI-Ticketzeilen zurückgegeben.',
    UnknownTicketRow: 'Unbekannte Ticketzeile',
    OpenProduct: 'Produkt #{{id}} öffnen',
    NotLinkedToProduct: 'Nicht mit einem Produktdatensatz verknüpft.',
    HistoryChanges_one: '{{count}} Änderung',
    HistoryChanges_other: '{{count}} Änderungen',
    HistoryTechnicalDetails: 'Technische Details',
    HistoryEntities: {
      product_box: 'Produktbereich',
      product_assignment: 'Produktzuordnung',
      ingredient_box: 'Zutatenbereich',
    },
    HistoryChangeTypes: { created: 'Erstellt', updated: 'Geändert', deleted: 'Gelöscht' },
    UnknownTimestamp: 'Unbekannter Zeitstempel',
    UserActor: 'Benutzer #{{id}}',
    SystemActor: 'System oder unbekannter Akteur',
    Retry: 'Erneut versuchen',
    UnableToLoadHistory: 'Verlauf konnte nicht geladen werden.',
    NoHistoryRows:
      'Für diesen Bereich gibt es noch keine Verlaufszeilen. Erstellungsereignisse werden im aktuellen Backend-Feed nicht gespeichert.',
    PageOf: 'Seite {{page}} von {{pages}}',
    AnalysisStillRunning: '{{label}} läuft noch. Aktualisieren Sie manuell, um das Ergebnis zu prüfen.',
    AnnotationsSaved: 'Annotationen gespeichert',
    SavingImageInBackground: 'Bild {{id}} ({{camera}}) wird im Hintergrund gespeichert…',
    BackgroundSaveFailed:
      'Bild {{id}} ({{camera}}) konnte nicht gespeichert werden. Ihre Änderungen bleiben erhalten. Öffnen Sie das Bild zum Prüfen und erneuten Speichern.',
    ReopenUnsavedImage: 'Bild {{id}} ({{camera}}) öffnen',
    StaleRevisionSaveRejected:
      'Speichern abgelehnt, weil die Revision veraltet ist. Aktualisieren Sie und versuchen Sie es erneut.',
    UnableToSaveAnnotations: 'Annotationen konnten nicht gespeichert werden.',
    ImageAnalysisRequested: 'Bildanalyse angefordert',
    ImageAnalysisLabel: 'Bildanalyse',
    UnableToStartImageAnalysis: 'Bildanalyse konnte nicht gestartet werden.',
    IngredientAnalysisRequested: 'Zutatenanalyse angefordert',
    IngredientAnalysisLabel: 'Zutatenanalyse',
    UnableToStartIngredientAnalysis: 'Zutatenanalyse konnte nicht gestartet werden.',
    ConfirmRestore: 'Originalbild für die aktive Kamera wiederherstellen?',
    OriginalImageRestored: 'Originalbild wiederhergestellt',
    UnableToRestoreOriginalImage: 'Originalbild konnte nicht wiederhergestellt werden.',
    StableLinkCopied: 'Stabiler Link kopiert',
    ClickToCopyId: 'Klicken, um die ID zu kopieren',
    CopyId: 'ID {{id}} kopieren',
    IdCopied: 'ID {{id}} kopiert',
    UnableToCopyId: 'ID konnte nicht kopiert werden',
    UnableToCopyLink: 'Link konnte nicht kopiert werden.',
    PollingInfo: '{{label}} läuft. Die Detailabfrage pollt nach einer neuen Revision.',
    ActiveFilters: 'Aktive Filter',
    NoExtraFilters: 'Keine zusätzlichen Filter aktiv.',
    MobileTabs: {
      results: 'Ergebnisse',
      workspace: 'Arbeitsbereich',
      inspector: 'Inspektor',
    },
  },
  BulkProductEdit: {
    Title: '{{count}} ausgewählte Produkt(e) aktualisieren',
    Field: 'Feld',
    Value: 'Wert',
    Apply: 'Anwenden',
  },
  RestaurantProductList: {
    Restaurant_Product_List_Title: 'Restaurant Produkte',
    Restaurant_Product_List_Heading: 'Restaurant Produkte',
    New_Product: 'Produkt hinzufügen',
    Products_Deleted_Successfully: 'Produkte erfolgreich gelöscht',
    Product_Delete_Error: 'Fehler beim Löschen des Produkts',
    Product_Added_To: 'Products added to the menu of ',
    Product_Name: 'Prodkt Name',
    Cash_Sys_Code: 'Cash System Code',
    Is_Recurrent: 'Wiederholt sich',
    Is_Industrial: 'Industriell',
    Is_Returned: 'Zurückgegeben',
    To_Count: 'Zu zählen',
    Object_Class: 'Art',
    TableToolbar: {
      Search_Product: 'Produkt suchen ...',
    },
    Choose_Date_Menu: 'Datum für das Menü auswählen',
    Add_To_Menu: 'Zum Menü hinzufügen',
    Delete_Products: 'Produkte löschen',
    Dense: 'Dichte',
    Rows_Per_Page: 'Produkte pro Seite',
    There_Is_Only: 'Achtung, es gibt nur',
    Excluded_From_Analysis: 'Dieses Produkt ist von der Analyse ausgeschlossen',
    Image: 'Bild',
    Must_Provide: 'für dieses produkt. Sie müssen mindestens 5 Bilder bereitstellen und sich an Trayvisor wenden.',
    Set_Is_Recurrent: 'In ein wiederkehrendes / nicht wiederkehrendes produkt umwandeln.',
    Cancel: 'Abbrechen',
    True: 'Wahr',
    False: 'Falsch',
    Product: 'Produkt',
    Original_Product: 'Originalprodukt',
    Linked_Ingredients: 'Verknüpfte Zutaten',
    Linked_Only: 'Nur verknüpfte',
    Unlinked_Only: 'Nur nicht verknüpfte',
    Is_Recurrent_Change: 'Status des wiederkehrenden Produkts geändert!',
    Bulk_Edit: 'Sammelbearbeitung',
    Bulk_Update_Success: 'Ausgewählte Produkte erfolgreich aktualisiert!',
    Bulk_Update_Error: 'Fehler beim Aktualisieren der ausgewählten Produkte',
  },
  RestaurantProductCreate: {
    Restaurant_Product_Create_Title: 'Produkte: Neues Produkt',
    Restaurant_Product_Create_Heading_Add: 'Neues Produkt anlegen',
    Restaurant_Product_Create_Heading_Edit: 'Produkt editieren',
    NewEditForm: {
      Restaurant_Products: 'Produkte',
      New_Product: 'Produkt hinzufügen',
      Filter_By_Object_Class: 'Filter nach Art des Objekts',
      Product: 'Produkt',
      Choose_Product: 'Produkt auswählen',
      Image_Example_Product: 'Produkt Beispielbild',
      Product_Required: 'Produkt ist erforderlich',
      Product_Name_Required: 'Produkt name ist erforderlich',
      CashSysCode_Required: 'Cash system code ist erforderlich',
      Product_Added_Success: 'Produkt erfolgreich zu Ihrem Restaurant hinzugefügt!',
      Product_Update_Success: 'Update erfolgreich!',
      Set_Up_Product: 'Produkt erstellen',
      Product_Name: 'Produkt Name',
      CashSysCode: 'Cash system Code',
      Is_Recurrent: 'Wiederholt sich',
      Is_Recurrent_Info: 'Sich wiederholende Produkte werden automatisch dem täglichen Menü hinzugefügt',
      Is_Returned: 'Zurückgegeben',
      Is_Returned_Info: 'Nicht zurückgegebene Produkte werden von den Analyseergebnissen ausgeschlossen',
      Add_Product: ' Produkt hinzufügen',
      Save_Changes: 'Änderungen speichern',
      Use_Daily_Products_only: 'Nur Tagesprodukte verwenden',
      Validated_As_Annotation: 'Als Annotation validiert',
      Start_Typing_Products: 'Tippen Sie, um Produkte anzuzeigen',
      Type_Minimum_Characters: 'Geben Sie mindestens {{count}} Zeichen ein',
      No_Products_Found: 'Keine Produkte gefunden',
      Linked_Ingredients: 'Verknüpfte Zutaten',
      Ingredient_Mapping_Title: 'Zutatenzuordnung',
      Ingredient_Mapping_Scope: 'Zuordnungsbereich',
      Ingredient_Mapping_Scope_Restaurant: 'Restaurant-Überschreibung',
      Ingredient_Mapping_Scope_Global: 'Global',
      Ingredient_Mapping_Helper_Text: 'Wählen Sie die Zutaten aus, die diesem Bereich zugeordnet werden sollen.',
      Ingredient_Mapping_Read_Only:
        'Sie können Zutatenzuordnungen ansehen, haben aber keine Berechtigung, sie zu ändern.',
      Inherited_Global_Ingredients: 'Geerbte globale Zutaten',
      Retry_Ingredient_Mapping: 'Synchronisierung erneut versuchen',
      Ingredient_Mapping_Save_Success: 'Zutatenzuordnungen erfolgreich gespeichert.',
      Ingredient_Mapping_Save_Error: 'Fehler beim Speichern der Zutatenzuordnungen.',
      Ingredient_Mapping_Save_Error_With_Conflicts:
        'Einige Zutaten sind in diesem Bereich bereits zugeordnet: {{conflicts}}.',
      Ingredient_Mapping_Partial_Error:
        'Das Restaurantprodukt wurde gespeichert, aber die Zutatenzuordnungen konnten nicht aktualisiert werden.',
      Ingredient_Mapping_Partial_Error_With_Conflicts:
        'Das Restaurantprodukt wurde gespeichert, aber diese Zutatenzuordnungen stehen im Konflikt: {{conflicts}}.',
      No_Ingredients_Found: 'Keine Zutaten gefunden',
      Select_Product_First: 'Wählen Sie zuerst ein Produkt aus',
    },
  },
  IngredientAnnotation: {
    Ingredients: 'Zutaten',
    No_Selection: 'Keine Auswahl',
    All: 'Alle',
    Validate_All_Ingredient_Boxes: 'Alle Zutatenkästen validieren',
    Unvalidate_All_Ingredient_Boxes: 'Alle Zutatenkästen devalidieren',
    Add_Ingredient_Box: 'Zutatenkasten hinzufügen',
    Save_Ingredient_Changes: 'Zutatenänderungen speichern',
    Analyze_Ingredients: 'Zutaten analysieren',
    Validated_As_Ingredient_Annotation: 'Als Zutatenannotation validiert',
    Not_Validated_As_Ingredient_Annotation: 'Nicht als Zutatenannotation validiert',
    Ingredient_Box_ID: 'Zutatenkasten-ID',
    Choose_Ingredient: 'Zutat auswählen',
    Ingredient: 'Zutat',
    Create_Ingredient: 'Zutat erstellen',
    Picker_Search: 'Zutaten suchen',
    Picker_Search_Placeholder: 'Name oder Code…',
    Picker_Results: 'Ergebnisse',
    Picker_Recent: 'Zuletzt verwendet',
    Picker_Categories: 'Kategorien',
    Picker_All_Categories: 'Alle Kategorien',
    Picker_Browse: 'Kategorien durchsuchen',
    Picker_Quick_Search: 'Schnellsuche',
    Picker_Back: 'Vorherige Kategorie',
    Picker_Open_Category: '{{name}} durchsuchen',
    Picker_Select_Category: '„{{name}}“ auswählen',
    Picker_No_Results: 'Keine Zutaten gefunden',
    Picker_Clear: 'Zutat entfernen',
    Close: 'Schließen',
    Ingredient_Name: 'Zutatenname',
    Ingredient_Name_Required: 'Zutatenname ist erforderlich',
    Ingredient_Description: 'Beschreibung',
    Validated_As_Annotation: 'Als Annotation validiert',
    Ingredient_Annotations_Crop_Title: 'Zutatenannotation: Zuschnitt',
    Ingredient_Annotations_Check_Title: 'Zutatenannotation: Prüfung',
    Ingredient_Annotations_Crop: 'Zuschnitt',
    Ingredient_Annotations_Check: 'Prüfung',
    Filters: 'Filter',
    Paging: 'Seiten',
    Restaurant: 'Restaurant',
    Dates: 'Dates',
    From_Date: 'Von Datum',
    To_Date: 'Bis Datum',
    Enrolled: 'Eingeschrieben',
    Offset: 'Versatz',
    Limit: 'Limit',
    Apply_Filter: 'Filter anwenden',
    Clear_Filter: 'Zurücksetzen',
    Sort_By: 'Sortieren nach',
    Sort_Newest: 'Neueste',
    Sort_Oldest: 'Älteste',
    Sort_Ingredient: 'Zutat',
    End_Of_List: 'Alles angezeigt.',
    Scroll_To_Top: 'Nach oben',
    Save_Product_Box_Error: 'Fehler beim Speichern der Produktbox-Änderungen',
    Ingredient_Save_Box_Error: 'Fehler beim Speichern der Zutatenbox, Admin kontaktieren!',
    Ingredient_Update_Box_Error: 'Fehler beim Aktualisieren der Zutatenbox, Admin kontaktieren!',
    Ingredient_Delete_Box_Error: 'Fehler beim Löschen der Zutatenbox, Admin kontaktieren!',
    Ingredient_Save_Success: 'Zutatenänderungen erfolgreich gespeichert',
    Ingredient_Save_Error: 'Fehler beim Speichern der Zutatenänderungen',
    Ingredient_Create_Success: 'Zutat erfolgreich erstellt',
    Ingredient_Create_Error: 'Fehler beim Erstellen der Zutat',
    Ingredients_Analysis_Done: 'Zutatenanalyse abgeschlossen',
    Ingredients_Analysis_Started: 'Zutatenanalyse gestartet, später wiederkommen',
  },
  ProductGeneral: {
    Product_Title: 'Produkte',
    Name: 'Produktname',
    Label: 'Produktbezeichnung',
    Description: 'Produktbeschreibung',
    Object_Class: 'Objektklasse (Erkennung)',
    Kind: 'Art',
    Family: 'Familie',
    Brand: 'Marke',
    Food_class: 'Lebensmittelklasse',
    Is_Industrial: 'Industriell',
    Is_Content: 'Container',
    To_Count: 'Zu zählen',
    Linked_Ingredients: 'Verknüpfte Zutaten',
    Search_Query_Too_Long: 'Die Suche darf höchstens {{max}} Zeichen enthalten.',
  },
  ProductList: {
    Product_List_Heading: 'Produkte',
    Product: 'Produkt',
    List: 'Liste',
    Add_Product: 'Produkt hinzufügen',
    Merge_Products: 'Produkte zusammenführen',
    Bulk_Edit: 'Sammelbearbeitung',
    Bulk_Update_Success: 'Ausgewählte Produkte erfolgreich aktualisiert!',
    Bulk_Update_Error: 'Fehler beim Aktualisieren der ausgewählten Produkte',
    TableHead: {
      Id: 'ID',
    },
    TableToolbar: {
      Search_Product: 'Produkt suchen...',
    },
    Dense: 'Dicht',
    Rows_Per_Page: 'Produkte pro Seite',
  },
  ProductCreate: {
    Product_Heading_Add: 'Ein neues Produkt hinzufügen',
    Product_Heading_Edit: 'Ein Produkt bearbeiten',
    New_Product: 'Neues Produkt',
    Set_Up_Product: 'Neues Produkt einrichten',
    Product_Name_Required: 'Produktname erforderlich',
    Description_Required: 'Beschreibung erforderlich',
    Label_Required: 'Etikett erforderlich',
    Is_Indus_Required: 'Industriell erforderlich',
    Is_Content_Required: 'Inhalt erforderlich',
    To_Count_Required: 'Zu zählen erforderlich',
    Kind_Required: 'Art erforderlich',
    Family_Required: 'Familie erforderlich',
    Brand_Required: 'Marke erforderlich',
    Object_Class_Required: 'Objektklasse erforderlich',
    Images_Required: 'Mindestens 1 Bild erforderlich',
    Product_Added_Success: 'Produkt erfolgreich hinzugefügt!',
    Branch_Added_Success: 'Marke erfolgreich hinzugefügt!',
    Food_Class_Added_Success: 'Lebensmittelklasse erfolgreich hinzugefügt!',
    Product_Update_Success: 'Aktualisierung erfolgreich!',
    Add_Product: 'Produkt hinzufügen',
    Save_Changes: 'Änderungen speichern',
    Add_Brand: 'Marke hinzufügen',
    Add_New_Brand: 'Neue Marke hinzufügen',
    Brand_Name: 'Markenname',
    Add_Food_Class: 'Lebensmittelklasse hinzufügen',
    Add_New_Food_Class: 'Neue Lebensmittelklasse hinzufügen',
    Enrolled_By: 'Registriert von',
    Is_Industrial_Info: 'Industrieprodukte sind verpackte Produkte.',
    Is_Content_Info: 'Für die Erkennung durch den Behälter (Teller).',
    To_Count_Info: 'Zutaten in diesem Produkt zählen',
    Image_Example_Product: 'Bildbeispiel',
    NutritionCard: {
      Set_Up_Nutrition_Card: 'Ernährungsinformationen einrichten',
      Calcium: 'Kalzium',
      Cho: 'KH (Kohlenhydrate)',
      Diet_fibre: 'Ballaststoffe',
      Diet_Iron: 'Eisen',
      Gross_Weight: 'Bruttogewicht',
      Kcal: 'Kcal',
      Net_Weight: 'Nettogewicht',
      Protein: 'Protein',
      Sat_Fat: 'Gesättigte Fettsäuren',
      Sodium: 'Natrium',
      Sugars: 'Zucker',
      Total_Fat: 'Gesamtfett',
    },
  },
  Products: {
    ClassOptions: {
      Class_All: 'Alle',
      Class_Indus_Food: 'Industriell',
      Class_Fruit: 'Früchte',
      Class_Drink: 'Getränke',
      Class_Dessert_Starter: 'Vorpseise/Dessert',
      Class_Dish: 'Gericht',
      Class_Bread: 'Brot',
      Class_Unknown: 'Unbekannt',
      Class_Others: 'Andere',
    },
  },
  Menus: {
    Menus_Title: 'Menüs',
    Menus_Header: 'Menüs',
    Menu_Date: 'Menüdatum',
    Menus_Card_Heading: 'Menus_Card_Heading', // to be translated
    Add_Products: 'Produkte zum Menü hinzufügen',
    Delete_From_Menu: 'Vom Menü löschen',
    Product_Removed_From_Menu_Success: 'Produkt vom Menü entfernt',
    Product_Remove_From_Menu_Error: 'Fehler beim Entfernen des Produkts vom Menü',
    Display_Menu_History: 'Menühistorie anzeigen',
    Last_Menu_Received_at: 'Letztes Menü erhalten am',
    No_Menu_Received_Today: 'Kein Menü heute erhalten',
    Menu_History: 'Menühistorie',
    Menu_History_Local_Time: 'Zeit in lokaler Zeitzone angezeigt (24h)',
  },
  Visualization: {
    Dashboard: 'Übersicht',
    Visualization: 'Visualisieren',
    Enrollment: 'Einschreibung',
    Analysis: 'Analyse',
    No_Enrollment_Found: 'Keine Einschreibung gefunden für',
  },
  Others: {
    All: 'Alle',
    True: 'Ja',
    False: 'Nein',
    Cancel: 'Stornieren',
    Delete: 'Löschen',
    Edit: 'Editieren',
    View_Annotations: 'Annotationen ansehen',
    Hide_Not_Returned_BBoxes: 'Nicht zurückgegebene Bboxes ausblenden',
    Returned_To_Client: 'An den Kunden zurückgegeben',
    Not_Returned_To_Client: 'Nicht an den Kunden zurückgegeben',
    Copy_BBox_ID: 'BBox-ID kopieren',
    Validate_BBox: 'Bounding Box validieren',
    Unvalidate_BBox: 'Validierung der Bounding Box aufheben',
    BBox_ID_Copied: 'BBox-ID kopiert',
    Detection_Score: 'Erkennungswert',
  },
  IdentificationToken: {
    Generate_Token_First: 'Bitte zuerst ein Token generieren',
    Token_Copied: 'Token in die Ablage kopiert',
    Identification_Title: 'Identifikation (Token)',
    Identification_Heading: 'Identifikations-Token',
    Admin: 'Admin',
    Expiration_Time: 'Verfallszeit (Tage)',
    Generate_Token: 'Identifikations-Token erstellen',
    Click_To_Copy: 'Click um zui kopieren',
    Click_To_Download: 'Click um herunterzuladen',
  },
  Selectors: {
    UsersSelector: 'Benutzer auswählen',
  },
  LanguageSelector: {
    Languages: 'Sprachen',
    en: 'Englisch',
    de: 'Deutsch',
    fr: 'Französisch',
  },
  ResetPassword: {
    Password_No_Match: 'Passwort stimmt nich überein',
    Password_Too_Short: 'Mindestens 8 Zeichen',
    Success: 'Erfolgreich',
    Invalid_Token: 'Ungültiges Token',
    Reset_Password: 'Passwort zurücksetzen',
    Password: 'Passwort',
    Confirm_Password: 'Passwort bestätigen',
    Confirm: 'Bestätigen',
  },
  Login: {
    Invalid_Login: 'Falscher Benutzername oder Passwort.',
    Successful_Login: 'Login erfolgreich',
    Login_Instructions: 'Gültigen Benutzernamen und Passwort eingeben.',
    Username: 'Email',
    Enter_Username: 'Benutzername eingeben',
    Password: 'Passwort',
    Enter_Password: 'Passwort eingeben',
    Connect: 'Anmeldung',
    Email_Must_Valid: 'Email muss eine gültige Email Adresse sein',
    Email_Required: 'Email ist erforderlich',
    Password_Required: 'Passwort ist erforderlich',
    Remember_Me: 'Anmeldedaten merken',
  },
  Reporting: {
    Reporting_Title: 'Berichte: Täglich',
    Reporting_Heading: 'Tägliche Berichte',
    Reporting: 'Berichterstattung',
    Daily: 'Täglich',
    Total_Trays: 'Gesamtzahl der Tabletts',
    Total_Tickets: 'Gesamtzahl der Tickets',
    Wrong_Trays: 'Falsche Tabletts',
    Perc_Of_Good_Trays: '% der guten Tabletts (netto)',
    Perc_Of_Good_Trays_Live: '% der guten Tabletts (brutto)',
    Product_Name: 'Produktname',
    Object_Class: 'Objektklasse (Erkennung)',
    Precision: 'Präzision',
    Recall: 'Rückruf',
    F1_Score: 'F1-Wert',
    TP_Description: 'Richtig Positiv:\nAnzahl der korrekt identifizierten Artikel.',
    FP_Description:
      'Falsch Positiv:\nAnzahl der falsch identifizierten Artikel. Wir haben vorhergesagt, dass der Artikel vorhanden war, aber er war es nicht.',
    FN_Description:
      'Falsch Negativ:\nAnzahl der nicht identifizierten Artikel. Wir haben vorhergesagt, dass der Artikel nicht vorhanden war, aber er war es.',
    Precision_Description: 'Präzision: Wie viel der vorhergesagten Artikel tatsächlich vorhanden sind.',
    Recall_Description: 'Rückruf: Wie viel der tatsächlichen Artikel vorhergesagt wurden.',
    F1_Score_Description: 'F1-Wert: Das harmonische Mittel aus Präzision und Rückruf.',
    Statistics_Per_Product: 'Statistiken pro Produkt',
    ObjectClasses_To_Remove: 'Objektklassen zum Entfernen',
  },
  Components: {
    BlockContent: {
      Drop_Or_Select_File: 'Datei ablegen oder auswählen',
      Drop_File_Or_Click: 'Dateien hier ablegen oder klicken',
      Browse: 'durchsuchen',
      Thorough_Your_Machine: 'Ihren Computer durchsuchen',
    },
    DeleteDialog: {
      Are_You_Sure: 'Sind Sie sicher, dass Sie ',
      Product: 'Produkt',
      Action_Cannot_Undone: 'Diese Aktion kann nicht rückgängig gemacht werden.',
    },
    MergeDialog: {
      Are_You_Sure: 'Sind Sie sicher, dass Sie ',
      Product: 'Produkt',
      Action_Cannot_Undone: 'Diese Aktion kann nicht rückgängig gemacht werden!',
      Merge: 'Zusammenführen',
    },
  },
  Clients: {
    Clients_Title: 'Kunden',
    Clients_Heading_List: 'Kunden Liste',
    New_Client: 'Neuer Kunden',
    TableToolbar: {
      Search_Client: 'Kunden suchen...',
    },
    TableHead: {
      Id: 'ID',
      ClientHash: 'Kunden Hash',
      Restaurant: 'Restaurant',
      Status: 'Status',
    },
    Form: {
      ClientHash: 'Kunden Hash',
      ClientHash_Required: 'Kunden Hash ist erforderlich',
      ActiveStatus: 'Aktiv Status',
      Status_Required: 'Status ist erforderlich',
      Create_Client: 'Kunden erstellen',
      Save_Changes: 'Änderungen speichern',
      Client_Created_Success: 'Kunde erfolgreich erstellt!',
      Client_Updated_Success: 'Kunde erfolgreich aktualisiert!',
    },
  },
};

export default de;
